import * as React from "react";
import { LazyRender } from "../LazyRender";
import { Box, Layout } from "@draftkings/arena-web";
import { SingleBetCard } from "./SingleBetCard";
import { ParlayBetCard } from "./ParlayBetCard";
import { RoundRobinBetCard } from "./RoundRobinBetCard";
import { SGPBetCard } from "./SGPBetCard";
import { MoonshotBetCard } from "./MoonshotBetCard";
import { getFunctionHandler } from "../../../../constants";
import { safeNumber } from "../../../../helpers";
import { shouldUpdateChunkHeight } from "./shouldUpdateChunkHeight";
import { debounce } from "debounce-decorator";
import { WinningCelebration } from "../WinningCelebration";
const betCardMap = new Proxy({
    Single: SingleBetCard,
    Parlay: ParlayBetCard,
    RoundRobin: RoundRobinBetCard,
    YourBet: SGPBetCard,
    Moonshot: MoonshotBetCard,
}, getFunctionHandler);
export const BetsChunk = React.memo(function BetsChunk(props) {
    const previousBets = React.useRef();
    // eslint-disable-next-line no-null/no-null
    const ref = React.useRef(null);
    const { bets, defaultHeight, chunkIndex, setActualChunkHeight } = props;
    const updateChunkHeight = debounce(() => {
        var _a;
        setActualChunkHeight(chunkIndex, safeNumber((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height));
    }, 300);
    React.useEffect(() => {
        if (shouldUpdateChunkHeight(previousBets.current, bets)) {
            updateChunkHeight();
        }
    });
    React.useEffect(() => {
        window.addEventListener("resize", updateChunkHeight);
        return () => {
            window.removeEventListener("resize", updateChunkHeight);
        };
    }, []);
    React.useEffect(() => {
        previousBets.current = bets;
    }, [bets]);
    return (React.createElement(React.Fragment, null, bets.length > 0 &&
        React.createElement(LazyRender, { baseMinHeight: defaultHeight },
            React.createElement(Box, { ref: ref }, bets.map(bet => {
                const BetCard = betCardMap[bet.betType];
                return (React.createElement(Layout, { variant: "betCardWrapper", key: bet.betId },
                    bet.showWinningCelebration && React.createElement(WinningCelebration, null),
                    React.createElement(BetCard, Object.assign({}, bet))));
            })))));
});
//# sourceMappingURL=BetsChunk.js.map